// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PostCorporaHotWordsBody, BaseResponseCorporaDataFoundResponse } from '../../types';

/**
 * 保存热词
 *
 * @export
 * @tags 热词, 语料库
 * @link [POST] /corpora/hotWords
 */
export function postCorporaHotWords(
    data: PostCorporaHotWordsBody
): Promise<BaseResponseCorporaDataFoundResponse>;
export function postCorporaHotWords(
    data: PostCorporaHotWordsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseCorporaDataFoundResponse>;
export function postCorporaHotWords(
    data: PostCorporaHotWordsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseCorporaDataFoundResponse> {
    return request<PostCorporaHotWordsBody, never, never>('/corpora/hotWords', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postCorporaHotWords',
    });
}

export const meta = [{ tags: ['热词', '语料库'], path: '/corpora/hotWords', method: 'post' }];
